import { Injectable } from '@angular/core';
import { UserDetails } from '../http/auth/model/user';
import { OutletRightsDTO } from '../outlet-cache/model/outlet';

@Injectable({
  providedIn: 'root',
})
export class UserCacheService {
  private readonly currentUserStorageKey = 'presto-user';

  constructor() {}

  /**
   * Returns an observable that emits the logged in user
   * @returns Stream of current user info
   */
  get(): UserDetails {
    return JSON.parse(
      sessionStorage.getItem(this.currentUserStorageKey) || 'null'
    ) as UserDetails;
  }

  /**
   * Saves the selected user in sessionStorage, and updates behaviorsubject
   * @param user Loggedin user
   */
  public setUser(user: UserDetails): void {
    sessionStorage.setItem(this.currentUserStorageKey, JSON.stringify(user));
  }

  public getUser(): UserDetails {
    return JSON.parse(
      sessionStorage.getItem(this.currentUserStorageKey) || 'null'
    ) as UserDetails;
  }

  public getOutletsRights(): OutletRightsDTO[] {
    let userDetails = JSON.parse(
      sessionStorage.getItem(this.currentUserStorageKey) || 'null'
    ) as UserDetails;
    return userDetails.outlets;
  }
}
